@if (content) {
  <div class="col-md-12 p-0 float-left border shadow-sm address-card">
    @if (content.header && !editMode) {
      <div class="card-header">
        {{ content.header }}
      </div>
    }
    <div class="col-md-12 pb-3 float-left" [class.pt-3]="!content.header" [class.pt-2]="content.header">
      @if (editMode) {
        <h4 class="col-md-12 p-0 pb-2 address-delete-msg text-info">
          {{ content.deleteMsg }}
        </h4>
      }
      @if (content.textBold) {
        <div class="col-md-12 p-0 address-header">
          {{ content.textBold }}
        </div>
      }
      <div class="col-md-12 p-0 address-items">
        @for (line of content.text; track line) {
          <div>
            <div class="text-muted address-item">{{ line }}</div>
          </div>
        }
      </div>
      <!-- Edit Mode Actions -->
      @if (editMode) {
        <div class="col-md-12 p-0 mt-3 float-left">
          <div class="col-md-6 float-left">
            <button class="btn btn-block btn-outline-primary btn-sm" (click)="cancelEdit()">
              {{ 'common.cancel' | cxTranslate }}
            </button>
          </div>
          <div class="col-md-6 float-left">
            <button class="btn btn-block btn-primary btn-sm" (click)="delete()">
              {{ 'common.delete' | cxTranslate }}
            </button>
          </div>
        </div>
      }
      <!-- Actions -->
      @if (content.actions && !editMode) {
        <div class="col-md-12 p-0 d-flex justify-content-end">
          @for (action of content.actions; track action) {
            <div>
              <div>
                @switch (action.event) {
                  @case ('delete') {
                    <a
                      class="address-card-link pl-2"
                      (click)="delete()"
                      (keydown.enter)="delete()"
                      tabindex="0"
                      >{{ action.name }}</a
                      >
                    }
                    @case ('default') {
                      <a
                        class="address-card-link pl-2"
                        (click)="setDefault()"
                        (keydown.enter)="setDefault()"
                        tabindex="0"
                        >{{ action.name }}</a
                        >
                      }
                      @case ('edit') {
                        <a
                          class="address-card-link pl-2"
                          (click)="edit()"
                          (keydown.enter)="edit()"
                          tabindex="0"
                          >{{ action.name }}</a
                          >
                        }
                        @default {
                          <a href="{{ action.link }}" class="address-card-link pl-2" tabindex="0">{{ action.name }}</a>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
